import React, { useState, useContext, useEffect, useRef } from "react";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import { FaFilter } from "react-icons/fa";
import { IoClose  } from "react-icons/io5";
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import { useLocation } from "react-router-dom";
import { BsArrowRightSquareFill } from "react-icons/bs";
import '../../styles/filterComponents.css';

/**
 * The Sidebar component is a popup overlay that displays refine search filters
 * @returns a JSX element.
 */
export default function Sidebar({ children }) {
    const {dropdown, setDropdown, setOpen, open, isMobile, setIsMobile} = useContext(PeFilterContext);
    const location = useLocation(); 
    const hasNumberInURLRef = useRef(false);

    useEffect(() => {
        
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [location.pathname, setIsMobile]);

    return (
        <div className="relative">
            {/* Filter Modal */}
            {open && (
                <div className="filter-modal" onClick={() => setOpen(false)}>
                    <div className="filter-modal-content" onClick={(e) => e.stopPropagation()}>
                        {/* Header */}
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-lg font-semibold text-[#BC8B20] flex items-center">
                                {/* <FaFilter className="mr-2" size={16} /> */}
                                <span className="font-bold text-[16px]">REFINE SEARCH</span>
                            </h2>
                            <button type="button" onClick={() => setOpen(false)} className="text-gray-500 hover:text-gray-700 transition-colors">
                                <IoClose size={24} />
                            </button>
                        </div>

                        {/* Filters Grid Layout */}
                        <div className="filter-grid flex-1 overflow-y-auto">
                            {children}
                        </div>

                        {/* Action Buttons */}
                        <div className="flex justify-end space-x-4 pt-4 border-t border-gray-200 mt-4">
                            <button 
                                type="button"
                                onClick={() => {
                                    // This will trigger the reset in the form
                                    const form = document.querySelector('form');
                                    if (form) form.reset();
                                }}
                                className="px-6 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
                            >
                                Reset
                            </button>
                            <button 
                                type="button"
                                onClick={() => {
                                    // This will trigger the submit in the form
                                    const form = document.querySelector('form');
                                    if (form) form.requestSubmit();
                                    setOpen(false);
                                }}
                                className="px-6 py-2 bg-[#bc8b20] text-white rounded-md hover:bg-[#a67a1b] transition-colors"
                            >
                                Apply Filters
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}